import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {down, eyebrow, focusRing} from "../../../Styles/media";

const PANEL_WIDTH = 380

const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: ${PANEL_WIDTH}px;
    max-width: 100vw;
    min-height: 100%;
    padding: 10px 0 24px;

    ${down('xs')} {
        width: 100vw;
    }
`

const Logo = styled.button`
    ${focusRing};
    font-family: ${({theme}) => theme.font.logo};
    font-size: 34px;
    line-height: 1;
    color: ${({theme}) => theme.color};

    &:hover {
        color: ${({theme}) => theme.accent};
    }
`

const Items = styled.nav`
    display: flex;
    flex-direction: column;
`

const Item = styled.button<{ $active: boolean }>`
    ${focusRing};
    position: relative;
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    padding: 16px 20px;
    text-align: left;
    border-bottom: 1px solid ${({theme}) => theme.lineFaint};
    background-color: ${({theme, $active}) => ($active ? 'rgba(255, 255, 255, 0.04)' : 'transparent')};
    transition: background-color 220ms ${({theme}) => theme.ease.out};

    &:hover {
        background-color: rgba(255, 255, 255, 0.06);
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 2px;
        background-color: ${({theme}) => theme.accent};
        opacity: ${({$active}) => ($active ? 1 : 0)};
        transition: opacity 220ms ${({theme}) => theme.ease.out};
    }
`

const ItemIndex = styled.span`
    font-family: ${({theme}) => theme.font.mono};
    font-size: 11px;
    letter-spacing: 0.1em;
    color: ${({theme}) => theme.colorFaint};
    padding-top: 4px;
`

const ItemText = styled.span`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`

const ItemLabel = styled.span`
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: ${({theme}) => theme.color};
`

const ItemDescription = styled.span`
    font-size: 12.5px;
    line-height: 1.45;
    color: ${({theme}) => theme.colorMuted};
`

const ItemArrow = styled(FontAwesomeIcon)`
    width: 13px;
    height: 13px;
    margin-left: auto;
    flex-shrink: 0;
    color: ${({theme}) => theme.colorFaint};
    transition: transform 240ms ${({theme}) => theme.ease.out}, color 240ms ${({theme}) => theme.ease.out};

    ${Item}:hover & {
        transform: translateX(4px);
        color: ${({theme}) => theme.accent};
    }
`

const Bottom = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: auto;
    padding: 24px 20px 0;
`

const BlockTitle = styled.span`
    ${eyebrow};
    font-size: 10px;
`

const LanguageRow = styled.div`
    display: flex;
    gap: 8px;
`

const LanguageButton = styled.button<{ $active: boolean }>`
    ${focusRing};
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 16px;
    border: 1px solid ${({theme, $active}) => ($active ? 'transparent' : theme.line)};
    border-radius: ${({theme}) => theme.radius.pill};
    font-size: 13px;
    font-weight: 700;
    color: ${({theme, $active}) => ($active ? theme.accentContrast : theme.colorMuted)};
    background-color: ${({theme, $active}) => ($active ? theme.color : 'transparent')};
    transition: color 200ms ${({theme}) => theme.ease.out}, background-color 200ms ${({theme}) => theme.ease.out};

    &:hover {
        color: ${({theme, $active}) => ($active ? theme.accentContrast : theme.color)};
    }
`

const ContactList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const ContactLink = styled.a`
    ${focusRing};
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 14.5px;
    font-weight: 600;
    color: ${({theme}) => theme.colorMuted};
    transition: color 200ms ${({theme}) => theme.ease.out};

    &:hover {
        color: ${({theme}) => theme.color};
    }
`

const ContactIcon = styled(FontAwesomeIcon)`
    width: 13px;
    height: 13px;
    color: ${({theme}) => theme.accent};
`

export const Styled = {
    Content,
    Logo,
    Items,
    Item,
    ItemIndex,
    ItemText,
    ItemLabel,
    ItemDescription,
    ItemArrow,
    Bottom,
    BlockTitle,
    LanguageRow,
    LanguageButton,
    ContactList,
    ContactLink,
    ContactIcon
}
